import calendar from '@web/routes/calendar/index';
import cv from '@web/routes/cv';
import general from '@web/routes/general';
import {
  notifications,
  profile,
  travelTime,
  rates
} from '@web/routes/settings';
import shifts from '@web/routes/shifts';
import { createRouter, createWebHashHistory } from 'vue-router';

declare module 'vue-router' {
  interface RouteMeta {
    title?: string;
  }
}

const routes = [
  ...general,
  ...calendar,
  ...cv,
  ...profile,
  ...shifts,
  ...rates,
  ...notifications,
  ...travelTime,
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export { router };
